import { mapActions, mapGetters } from 'vuex';
import marketContractHorizontalV2 from '@/components/market/v2/market-contract-horizontal-v2/market-contract-horizontal-v2.vue';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  props: {
    market: {
      type: Object,
      required: true,
    },
  },
  components: {
    marketContract: marketContractHorizontalV2,
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    onContractClick(data) {
      if (!this.isLoggedIn) {
        this.setCurrentPopup(MODALS.LOGIN);
      } else {
        const { contractId } = data;
        this.$router.push({
          name: 'market-details',
          params: {
            marketId: this.market.marketId,
            marketUrl: this.market.marketUrl,
          },
          query: {
            contractId,
          },
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/cms/market-contract-list-v2-embed/market-contract-list-v2-embed.js